(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_1bcdcb1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sandluz-video-carousel')) {
    class SandluzVideoCarousel extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.autoplayTimer = null;
        this.abortController = null;
        this.intersectionObserver = null;
        this.isVisible = false;
        this.interactionPaused = false;
        this.userPaused = false;
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.handleInteractionStart = this.handleInteractionStart.bind(this);
        this.handleInteractionEnd = this.handleInteractionEnd.bind(this);
        this.handleMotionPreferenceChange = this.handleMotionPreferenceChange.bind(this);
      }

      connectedCallback() {
        this.disconnect();
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.track = this.querySelector('[data-carousel-track]');
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.toggleButton = this.querySelector('[data-carousel-toggle]');
        this.toggleLabel = this.querySelector('[data-carousel-toggle-label]');
        this.status = this.querySelector('[data-carousel-status]');
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.interval = Math.max((parseInt(this.dataset.interval, 10) || 3) * 1000, 2000);
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motionQuery.matches;

        if (!this.track || this.slides.length === 0) return;

        this.setupEventListeners(signal);
        this.setupIntersectionObserver();
        this.updateCarousel(false);
        this.updatePlaybackButton();
      }

      setupEventListeners(signal) {
        this.prevButton?.addEventListener('click', () => {
          this.pausePermanently();
          this.goToPrevious();
        }, { signal });

        this.nextButton?.addEventListener('click', () => {
          this.pausePermanently();
          this.goToNext();
        }, { signal });

        this.toggleButton?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updatePlaybackButton();
          this.announce(this.userPaused ? this.dataset.pausedStatus : this.dataset.playingStatus);
          this.syncPlayback();
        }, { signal });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.pausePermanently();
            this.goToSlide(index);
          }, { signal });
        });

        this.addEventListener('mouseenter', this.handleInteractionStart, { signal });
        this.addEventListener('mouseleave', this.handleInteractionEnd, { signal });
        this.addEventListener('focusin', this.handleInteractionStart, { signal });
        this.addEventListener('focusout', this.handleInteractionEnd, { signal });
        document.addEventListener('visibilitychange', this.handleVisibilityChange, { signal });
        this.motionQuery.addEventListener('change', this.handleMotionPreferenceChange);
      }

      setupIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          this.isVisible = Boolean(entry?.isIntersecting && entry.intersectionRatio > 0);
          this.syncPlayback();
        }, { threshold: [0, 0.1] });
        this.intersectionObserver.observe(this);
      }

      goToSlide(index) {
        if (index < 0 || index >= this.slides.length) return;
        this.currentIndex = index;
        this.updateCarousel(true);
      }

      goToNext() {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        this.updateCarousel(true);
      }

      goToPrevious() {
        this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
        this.updateCarousel(true);
      }

      updateCarousel(shouldAnnounce) {
        this.track.style.transform = `translateX(${-this.currentIndex * 100}%)`;

        this.dots.forEach((dot, index) => {
          const isCurrent = index === this.currentIndex;
          dot.classList.toggle('is-active', isCurrent);
          if (isCurrent) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        this.slides.forEach((slide, index) => {
          const isCurrent = index === this.currentIndex;
          slide.toggleAttribute('inert', !isCurrent);
          if (isCurrent) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
        });

        this.pauseAllVideos();
        this.prepareCurrentPosters();

        if (shouldAnnounce) {
          this.announce(this.slides[this.currentIndex]?.getAttribute('aria-label') || '');
        }

        this.syncPlayback();
      }

      prepareCurrentPosters() {
        const currentSlide = this.slides[this.currentIndex];
        if (!currentSlide || !this.isVisible) return;

        currentSlide.querySelectorAll('video[data-poster]').forEach((video) => {
          if (!video.poster) video.poster = video.dataset.poster;
        });
      }

      loadCurrentSources() {
        const currentSlide = this.slides[this.currentIndex];
        if (!currentSlide) return;

        currentSlide.querySelectorAll('video').forEach((video) => {
          if (video.dataset.sourcesLoaded === 'true') return;

          video.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
          });
          video.dataset.sourcesLoaded = 'true';
          video.load();
        });
      }

      playCurrentVideos() {
        const currentSlide = this.slides[this.currentIndex];
        if (!currentSlide || this.userPaused || !this.isVisible || document.hidden) return;

        this.loadCurrentSources();
        currentSlide.querySelectorAll('video').forEach((video) => {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });
      }

      pauseAllVideos() {
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      syncPlayback() {
        this.stopAutoplay();

        if (!this.isVisible || document.hidden || this.userPaused) {
          this.pauseAllVideos();
          if (this.isVisible) this.prepareCurrentPosters();
          return;
        }

        this.prepareCurrentPosters();
        this.playCurrentVideos();

        if (this.autoplayEnabled && !this.interactionPaused && this.slides.length > 1) {
          this.startAutoplay();
        }
      }

      startAutoplay() {
        this.stopAutoplay();
        this.autoplayTimer = window.setTimeout(() => {
          this.goToNext();
        }, this.interval);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          window.clearTimeout(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      pausePermanently() {
        this.userPaused = true;
        this.updatePlaybackButton();
        this.stopAutoplay();
        this.pauseAllVideos();
      }

      updatePlaybackButton() {
        if (!this.toggleButton) return;
        const label = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.classList.toggle('is-paused', this.userPaused);
        this.toggleButton.setAttribute('aria-pressed', String(this.userPaused));
        this.toggleButton.setAttribute('aria-label', label);
        this.toggleButton.title = label;
        if (this.toggleLabel) this.toggleLabel.textContent = label;
      }

      announce(message) {
        if (!this.status || !message) return;
        this.status.textContent = '';
        window.requestAnimationFrame(() => {
          this.status.textContent = message;
        });
      }

      handleVisibilityChange() {
        this.syncPlayback();
      }

      handleInteractionStart() {
        this.interactionPaused = true;
        this.stopAutoplay();
      }

      handleInteractionEnd(event) {
        if (event.type === 'focusout' && this.contains(event.relatedTarget)) return;
        this.interactionPaused = false;
        this.syncPlayback();
      }

      handleMotionPreferenceChange(event) {
        if (!event.matches) return;
        this.userPaused = true;
        this.updatePlaybackButton();
        this.syncPlayback();
      }

      disconnect() {
        this.stopAutoplay();
        this.pauseAllVideos();
        this.intersectionObserver?.disconnect();
        this.intersectionObserver = null;
        this.motionQuery?.removeEventListener('change', this.handleMotionPreferenceChange);
        this.abortController?.abort();
        this.abortController = null;
      }

      disconnectedCallback() {
        this.disconnect();
      }
    }

    customElements.define('sandluz-video-carousel', SandluzVideoCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
